import * as React from 'react';
import { useSelector } from 'react-redux';
import { useInView } from '@cian/valuation-utils-component';
import { Reviews } from '../../components/Reviews';
import { MOSCOW_AREA_REGION_ID, MOSCOW_REGION_ID, MOSCOW_WITH_AREA_REGION_ID } from '../../constants/geoSwitcher';
import { useTracking } from './hooks';
import { selectSubdomainRegionId } from '../../selectors/selectSubdomainRegionId';

export const reviews = [
  {
    title: '«Император», компания «Теремъ»',
    imageUrl: 'https://content.cdn-cian.ru/realty/uploads/froala_editor/images/1_2_wO0Pa0A.jpg',
    url: 'https://www.cian.ru/stati-zagorodnye-proekty-kottedzh-imperator-kompanija-terem-326547/',
  },
  {
    title: '«Аврора 2», компания «Зодчий»',
    imageUrl: 'https://content.cdn-cian.ru/realty/journal/324688/avrora_2_qgtA9mu.jpg',
    url: '/stati-zagorodnye-proekty-avrora-2-kompanija-zodchij-324688/',
  },
  {
    title: '«Сканди 161», компания «Избург»',
    imageUrl: 'https://content.cdn-cian.ru/realty/journal/324474/1_1_MFsDQsU.jpg',
    url: '/stati-zagorodnye-proekty-skandi-161-kompanija-izburg-324474/',
  },
  {
    title: 'СП-4, компания Good Wood',
    imageUrl: 'https://content.cdn-cian.ru/realty/journal/324334/3.jpg',
    url: '/stati-zagorodnye-proekty-sp-4-kompanija-good-wood-324334/',
  },
];

export const ReviewsContainer = () => {
  const subdomainRegionId = useSelector(selectSubdomainRegionId);
  const reviewsAvailableInRegions = [MOSCOW_REGION_ID, MOSCOW_AREA_REGION_ID, MOSCOW_WITH_AREA_REGION_ID];

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  const { handleReviewItemClick, handleAllReviewsClick } = useTracking(inView);

  if (!reviewsAvailableInRegions.includes(subdomainRegionId)) {
    return null;
  }

  return (
    <div ref={ref}>
      <Reviews reviews={reviews} onReviewItemClick={handleReviewItemClick} onAllReviewsClick={handleAllReviewsClick} />
    </div>
  );
};
